import { BFFAgent } from 'BFFAgent'
import {
    INTEGRATION_DATA_BEGIN,
    INTEGRATION_DATA_SUCCESS,
    INTEGRATION_DATA_FAILURE,
    CLEAN_INTEGRATION_DATA_SUCCESS,
    CLEAN_INTEGRATION_DATA_FAILURE
} from './constants'
import { DEFAULT_CLIENT_BUSINESS_TYPE } from '../../clientes/constants'

export function comeFromSalesforce(id) {
    return async dispatch => {
        try {
            dispatch({
                type: INTEGRATION_DATA_BEGIN
            })

            const res = await BFFAgent.User.getIntegrationData(id)
            dispatch({
                type: INTEGRATION_DATA_SUCCESS,
                data: res.data.data
            })
        } catch (error) {
            dispatch({
                type: INTEGRATION_DATA_FAILURE,
                data: { error }
            })
        }
    }
}

export function cleanSalesforceData() {
    return async dispatch => {
        try {
            dispatch({
                type: CLEAN_INTEGRATION_DATA_SUCCESS
            })

          
        } catch (error) {
            dispatch({
                type: CLEAN_INTEGRATION_DATA_FAILURE,
                data: { error }
            })
        }
    }
} 
export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_DATA_BEGIN:
            return {
                ...state,
                user: {
                    ...state.user,
                    comeFromSalesforce: false,
                    integrationDataLoading: true,
                    integrationData:{}
                }
            }
        case INTEGRATION_DATA_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    comeFromSalesforce: true,
                    integrationDataLoading: false,
                    integrationData: action.data.data
                },
                client: {
                    firstname: action.data.data.client.first_name,
                    lastname: action.data.data.client.last_name,
                    email: action.data.data.client.email,
                    phone: action.data.data.client.phone_number,
                    client_type: action.data.data.client.client_type,
                    client_business_type: action.data.data.client.client_business_type || DEFAULT_CLIENT_BUSINESS_TYPE,
                },
            }
        case INTEGRATION_DATA_FAILURE:
            return {
                ...state,
                user: {
                    ...state.user,
                    comeFromSalesforce: false,
                    integrationDataLoading: false,
                    integrationData: action.data.error
                }
            }
        case CLEAN_INTEGRATION_DATA_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    comeFromSalesforce: false,
                    integrationDataLoading: false,
                    integrationData: {}
                }
            }
        case CLEAN_INTEGRATION_DATA_FAILURE:
            return {
                ...state,
                user: {
                    ...state.user,
                    comeFromSalesforce: false,
                    integrationDataLoading: false,
                    integrationData: {},
                    cleanErrorMessage: action.data.error
                }
            }
        default:
            return state
    }
}
